import React from 'react';

import { Button, ButtonParams, ButtonStyle } from '../button/revamp-button';
import './revamp-button-group.scss';

export type ButtonConfig = {
  label: string;
  automationId: string;
  className?: string;
  disabled?: boolean;
  buttonStyle: ButtonStyle;
  buttonParams: ButtonParams;
  type?: string;
};

export enum LayoutType {
  CENTERED = 'centered',
  FULL_WIDTH = 'full-width',
}

export type ButtonContainer = (children: React.ReactFragment) => React.ReactFragment;

export type ButtonGroupProps = {
  buttons: Array<ButtonConfig>;
  layoutType: LayoutType;
  [rest: string]: any;
};

export default function ButtonGroup(props: ButtonGroupProps) {
  const { layoutType, buttons, ...rest } = props;

  return (
    <div className={`RevampButtonGroup ${layoutType}`}>
      <div className="container">
        {buttons.map((button, index) => (
          <Button
            key={`${button.label} ${index}`}
            type={button.type}
            automationid={button.automationId}
            buttonStyle={button.buttonStyle}
            className={button.className ? button.className : ''}
            buttonParams={button.buttonParams}
            disabled={button.buttonParams.disabled}
            {...rest}
          >
            {button.label}
          </Button>
        ))}
      </div>
    </div>
  );
}
